
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InformationOverlay } from '@hvcgroep/design-system';
import { RegistrationDeskStepComponent } from '../../types/multistep-form';
import PricingStructureTable from '../../containers/PricingStructureTable';

const PricingStructure: RegistrationDeskStepComponent<'goBack'> = (props) => {
  const { t } = useTranslation();
  const { onProceed, context } = props;

  const eamData = context.eamData!;
  const sjvGJ = String(context.usageGJ!);

  return (
    <InformationOverlay
      onCloseButtonClick={() => onProceed({})}
    >
      <div>
        <h1>{t('registration_desk.screens.pricing_structure.title')}</h1>
        <PricingStructureTable sjvGJ={sjvGJ} ean={eamData.Ean} />
      </div>
    </InformationOverlay>
  );
};

export default PricingStructure;
